// extracted by mini-css-extract-plugin
module.exports = {"badge":"event-badge_badge__Nc2BL"};